
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/_theatrical-pif/[slug]",
      function () {
        return require("private-next-pages/[locale]/_theatrical-pif/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/_theatrical-pif/[slug]"])
      });
    }
  